/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import qs from 'qs';

/**
 * The images on the PDP page are broken up into multiple components:
 *  1. GraphqlProductImageUIMobile
 *      - ProductPlaImageUIMobile
 *      - ProductImageUIMobileBlock
 *  2. GraphqlProductImageUI
 *
 * all with unique implementations. Consolodate some logic here
 * to make integration with Pmall preview images a bit easier.
 */

const previewImageName = '';

/**
 * @descriptions Takes an object with required information and build the url to hit.
 * @param {{mobileURL:string; imageURL:string; count:number;}} pmallData
 * @param {boolean} mobile
 * @returns {string} url
 *
 * @note The pmallData param should be the postData coming from the iFrame on completion.
 */
const buildURL = (pmallSummaryInfo, mobile) => {
    let url = `https:${pmallSummaryInfo?.customizations?.imageURL}`;
    if (mobile) {
        url = `https:${pmallSummaryInfo?.customizations?.mobileURL}`;
    }
    /**
     * The urls recieved from pmall dont change after an edit workflow
     * which causes problem with updates the image due to caching.
     *
     * Use a count appended to the data to prevent caching.
     * Count is appended within GraphqlProductPageBuilder.handlePmallFinish
     */

    // seperate base and query
    const [base, oldQueryString] = url.split('?');

    // turn it into an object
    // if an empty string or undefined is passed because there is
    // no query, an empty object is returned
    const queryParams = qs.parse(oldQueryString);

    // add the cacheBust parameter either way
    queryParams.cacheBust = pmallSummaryInfo?.countCacheBust;

    // stringify
    const newQueryString = qs.stringify(queryParams);

    // join
    url = `${base}?${newQueryString}`;

    return url;
};

export default { previewImageName, buildURL };
